import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestSubmitTrackPolicyDto, ResponseTrackPolicy, ResponseTrackPolicyDto } from "../../gd-integrated/dto/policy.dto";
import { NestApiProvider } from "../../nest-api";
import { ResponseData } from "../../nest-responses";
import { RequestPagingDto } from "../dto/base.dto";

@Injectable()
export class PolicyApi {

  private service: string = '';
  private model: string = 'policy';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getTrackPolicy(queryParams: RequestPagingDto) {

    const method: string = 'GET';
    const func: string = 'getTrackPolicy';
    const params: any = {};
    const urlParams: any = queryParams;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseTrackPolicyDto[]>>(method, url, params, urlParams, body);
  }

  submitTrackPolicy(payload: RequestSubmitTrackPolicyDto[]): Observable<any> {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "submitTrackPolicy";
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/policy.api.ts